import { render, staticRenderFns } from "./AddCommercialConfig.vue?vue&type=template&id=703c0561&"
import script from "./AddCommercialConfig.vue?vue&type=script&lang=js&"
export * from "./AddCommercialConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddCommercialConfig.vue"
export default component.exports